import { Content } from "interfaces/content";
import React, {
  createContext,
  ReactNode,
  useCallback,
  useContext,
  useEffect,
  useState,
} from "react";
import PageLoader from "ui/Loader/Page";

interface Props {
  children: ReactNode;
}

interface AppContextValues {
  isLoading: boolean;
  setIsLoading: (isLoading: boolean) => void;
  content: Content | null;
  handleSetContent: (newActiveContent: Content) => void;
}

const AppContext = createContext<AppContextValues>({
  isLoading: false,
  setIsLoading: () => {},
  content: null,
  handleSetContent: () => {},
});

const AppProvider: React.FC<Props> = ({ children }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [content, setContent] = useState<Content | null>(null);

  useEffect(() => {
    if (content) {
      document.title = `DataRede - ${content.name}`;
    }
  }, [content]);

  const handleSetContent = useCallback((newActiveContent: Content) => {
    setContent(newActiveContent);
  }, []);

  return (
    <AppContext.Provider value={{ isLoading, setIsLoading, content, handleSetContent }}>
      {children}
      {isLoading && <PageLoader />}
    </AppContext.Provider>
  );
};

export default AppProvider;

export const useAppContext = (): AppContextValues => useContext(AppContext);
